import type {CSSProperties} from 'react';
import type {TextSegment} from '../../vendor/src/features/remotion-editor/editor/items/text/text-item-type';
/** Read-only rich text must not attach Lexical's MutationObserver while the web renderer splits glyph nodes. */
export function StaticRichText({text,segments,style}:{text:string;segments?:TextSegment[];style:CSSProperties}){
  const runs=segments?.length?segments:[{text}];
  return <div style={style} className="rich-text-content-editable"><p style={{margin:0,padding:0,textAlign:'inherit'}}>{runs.map((segment,index)=><span key={index} style={{
    color:segment.color,WebkitTextStrokeColor:segment.strokeColor,fontFamily:segment.fontFamily,
    fontWeight:segment.fontWeight as CSSProperties['fontWeight'],fontStyle:segment.fontVariant as CSSProperties['fontStyle'],
    fontSize:segment.fontSize,opacity:segment.opacity,
  }}>{segment.text}</span>)}</p></div>;
}
